<template>
  <div>

    <!-- Category Inspiration
    https://www.asos.com/au/women/
    https://www.shopbop.com/clothing/br/v=1/13266.htm
    https://aus.spell.co/collections/bottoms
    https://www.net-a-porter.com/en-au/shop/clothing/jeans -->

    <a class="admin__link" @click="validateCategories__clicked">Validate Categories</a>
    <br /><br />


    <table class="admin__table" style="min-width: 1250px;">
      <tr v-for="(product, index) in shopify_products" :key="index">
        <td>
         <img :src="product.small_image_url" style="width:300px;" />
        </td>
        <td>{{index}}</td>
        <td>
          <div><router-link :to="admin_site_path(product.potential_shopify_site_document_id)">{{ product.shopify_site_document_id }}</router-link></div>
          <div><a :href="product.origin_url" target="_blank">{{ product.title }}</a></div>
          <div><small>Price</small>${{product.variants[0].price}}</div>
          <div><small>Date</small>{{ product.published_at.toDate().toLocaleDateString('en-GB')}}</div>
          <div><small>Product Type:</small> {{product.product_type}}</div>
          <div><small>Vendor:</small> {{product.vendor }}</div>
          <div><small>Category:</small></div>
          <div>{{product.category}} - {{product.subcategory}}</div>

          <div>Image: {{ product.main_image_index }}</div>
          <div>
            <a @click.prevent="incrementImageIndex(product, -1)">Prev</a>
            &nbsp;
            <a @click.prevent="incrementImageIndex(product, 1)">Next</a>
          </div>

          <div>{{ displayState(product) }}</div>
          <a class="admin__button admin__button--red" style="width:150px;" @click="setDisplayState(product, display_state.HIDE_FROM_SITE, index)">Reject</a>
        </td>

        <td>
          <div>

            <div style="display:flex; gap:50px;">
              <div v-for="categories in category_columns">
                <a v-for="(category, category_index) in categories"
                   class="admin__category-link"
                   :class="{'admin__category-link--sublink': category.is_subcategory}"
                   :key="category_index"
                    @click="category__clicked(index, product, category)">
                  <span v-if="category.is_subcategory">{{ category.subcategory }}</span>
                  <span v-else>{{ category.category }}</span>
                </a>
              </div>
            </div>


            <!-- </div> -->

          </div>


          <!--
          <div class="admin__table-columns">
            <div><small>Tags:</small></div>
            <div v-html="product.tags.join('<br />')"></div>
          </div> -->
        </td>


       <!-- <td>
          <div>{{ displayState(product) }}</div>
          <a class="admin__button admin__button--red" @click="setDisplayState(product, display_state.HIDE_FROM_SITE, index)">Reject</a>
          <a class="admin__button" v-if="product.subcategory" @click="setDisplayState(product, display_state.SHOW_ON_SITE, index)">Approve</a>
          <a class="admin__button admin__button--green" v-if="product.subcategory" @click="setDisplayState(product, display_state.PROMOTE_ON_SITE, index)">Promote</a>
        </td> -->

      </tr>
    </table>

    <div style="margin-top: 20px;">
      <a class="admin__link" @click="nextPage__clicked">Next Page</a>
    </div>

  </div>
</template>

<script>
import ShopifyProduct from '../../../models/ShopifyProduct'
import SiteCollectionMapping from '../../../models/SiteCollectionMapping'
import Category from "../../../models/Category";
import Facebook from "../../../utilites/facebook";

export default {
  data(){
    return{
      shopify_products: [],
      category_columns: [],
      display_state: ShopifyProduct.DisplayState,
      site_collection_mappings: [],
    }
  },
  async mounted(){
    let all_categories = Category.toIndentedFlatArray();
    let split_1 = 26;
    let split_2 = 49;
    this.category_columns.push(all_categories.slice(1, split_1));
    this.category_columns.push(all_categories.slice(split_1, split_2));
    this.category_columns.push(all_categories.slice(split_2));

    //this.site_collection_mappings = await SiteCollectionMapping.all();

    await this.loadProducts();
  },
  computed:{

  },
  methods: {
    displayState(product){

     // let prices = product.variants.map(variant => variant.price);// filter((value, index, self) => self.indexOf(value) === index);
     // Math.min(...prices)
      //return  Math.min(...prices) + ' ' + Math.max(...prices);
     return ShopifyProduct.DisplayState.name(product.display_state) + ': ' + product.display_state;
    },
    subcategoriesForProduct(product){
      return product.category ? this.categories.find( c => c.name == product.category).subcategories : [];
    },
    async setDisplayState(product, display_state, array_index){
        product.display_state = display_state;
        console.log("ds", product.display_state);
        await product.save();
        this.shopify_products .splice(array_index, 1);
    },
    async loadProducts(){
      this.shopify_products = await ShopifyProduct.requiresApprovalPage();
    },
    async nextPage__clicked(event){
      this.shopify_products = await ShopifyProduct.requiresApprovalPage( this.lastProductPublishedDate() );
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    },
    async category__clicked(array_index, product, category_object){
       product.category_object = category_object;
       product.display_state = ShopifyProduct.DisplayState.SHOW_ON_SITE;
       //console.log("ds", product.display_state);
       await product.save();
       this.shopify_products .splice(array_index, 1);
    },
    lastProductPublishedDate(){
      return this.shopify_products[this.shopify_products.length - 1].published_at.toDate();
    },
    incrementImageIndex(product, direction){
      product.main_image_index = Math.max(0, Math.min(product.images.length - 1, parseInt(product.main_image_index) + direction));
    },

    // Categories

    validateCategories__clicked(event){
        alert("Categories: " + (Category.validateCategories() ? "Valid" : "Invalid"));
    },

  }

}
</script>
